export default __webpack_public_path__ + "static/media/Emmalyn.9127726a.png";